import ApiError from 'utils/api/errors/ApiError';


class ApiNetworkAuthRequiredError extends ApiError {
  constructor (props) {
    super(props);
    this.name = 'ApiNetworkAuthRequiredError';
  }
}

export default ApiNetworkAuthRequiredError;
